import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_RAW_RETAILER_ASSOCIATION = gql`
  mutation CreateMasterDataRawRetailerAssociation(
    $params: CreateMasterDataRawRetailerAssociationInput!
  ) {
    createMasterDataRawRetailerAssociation(params: $params) {
      rawRetailerId
      rawRetailerName
      retailerId
      retailerName
    }
  }
`;

export const UPDATE_MASTER_DATA_RAW_RETAILER_ASSOCIATION = gql`
  mutation UpdateMasterDataRawRetailerAssociation(
    $params: UpdateMasterDataRawRetailerAssociationInput!
  ) {
    updateMasterDataRawRetailerAssociation(params: $params) {
      rawRetailerId
      rawRetailerName
      retailerId
      retailerName
    }
  }
`;
